/** ARFreaks' categories with posts (46 of 48 on 2026-10-26, from its WordPress API, most posts first). A category page is /{slug}/, the same
 * address as a tag of that name, so choosing one is the same as searching that word. */
export const ARFREAKS_CATEGORIES = [
  { slug: "blowjob", label: "Blowjob" },
  { slug: "cowgirl", label: "Cowgirl" },
  { slug: "handjob", label: "Handjob" },
  { slug: "reverse-cowgirl", label: "Reverse Cowgirl" },
  { slug: "doggystyle", label: "Doggystyle" },
  { slug: "missionary", label: "Missionary" },
  { slug: "tease", label: "Tease" },
  { slug: "natural-tits", label: "Natural Tits" },
  { slug: "shaved-pussy", label: "Shaved Pussy" },
  { slug: "cumshots", label: "Cumshots" },
  { slug: "brunette", label: "Brunette" },
  { slug: "babe", label: "Babe" },
  { slug: "masturbation", label: "Masturbation" },
  { slug: "alpha", label: "Alpha" },
  { slug: "big-tits", label: "Big Tits" },
  { slug: "small-tits", label: "Small Tits" },
  { slug: "blonde", label: "Blonde" },
  { slug: "lingerie", label: "Lingerie" },
  { slug: "fingering", label: "Fingering" },
  { slug: "teen-18", label: "Teen (18+)" },
  { slug: "titty-fuck", label: "Titty Fuck" },
  { slug: "solo", label: "Solo" },
  { slug: "petite", label: "Petite" },
  { slug: "big-ass", label: "Big Ass" },
  { slug: "toys", label: "Toys" },
  { slug: "creampie", label: "Creampie" },
  { slug: "cgi", label: "CGI" },
  { slug: "milf", label: "MILF" },
  { slug: "footjob", label: "Footjob" },
  { slug: "latina", label: "Latina" },
  { slug: "red-head", label: "Red Head" },
  { slug: "asian", label: "Asian" },
  { slug: "orgasm", label: "Orgasm" },
  { slug: "hairy-pussy", label: "Hairy Pussy" },
  { slug: "anal", label: "Anal" },
  { slug: "ebony", label: "Ebony" },
  { slug: "facesitting", label: "Facesitting" },
  { slug: "fetish", label: "Fetish" },
  { slug: "hentai", label: "Hentai" },
  { slug: "facial", label: "Facial" },
  { slug: "squirting", label: "Squirting" },
  { slug: "massage", label: "Massage" },
  { slug: "bbw", label: "BBW" },
  { slug: "threesome", label: "Threesome" },
  { slug: "compilation", label: "Compilation" },
  { slug: "free-full-videos", label: "Free Full Videos" },
] as const
